<template>
    <div>
        <div class="py-2" v-for="(answer, index) in answerList" :key="index">
            <hr v-if="index > 0" class="mx-3"/>
            <div class="p-1">
                <div class="py-1 d-flex align-items-center">
                    <span>
                        {{ translate('Answer type') + ' [[' + (+index + 1) + ']]' }}
                    </span>
                    <button class="btn border-0" @click="removeAnswer($event, index)">
                        <i class="fa-solid fa-trash-can"></i>
                    </button>
                </div>
                <div class="py-1">
                    <input
                            type="radio"
                            :name="'answer_type_' + index"
                            :id="'answer-type-' + index + '-single-choice'"
                            v-model="answer.type"
                            :value="'single-choice'"
                            v-on:keydown.enter.prevent=""
                            @click="switchAnswerType($event, index)"
                    />
                    <label class="pr-5 cursor-pointer" :for="'answer-type-' + index + '-single-choice'">
                        {{ translate('single choice') }}
                    </label>

                    <input
                            type="radio"
                            :name="'answer_type_' + index"
                            :id="'answer-type-' + index + '-short-answer'"
                            v-model="answer.type"
                            :value="'short-answer'"
                            v-on:keydown.enter.prevent=""
                            @click="switchAnswerType($event, index)"
                    />
                    <label class="cursor-pointer" :for="'answer-type-' + index + '-short-answer'">
                        {{ translate('short answer') }}
                    </label>
                </div>
            </div>
            <div v-if="answer.type === answerTypes['single-choice']" class="p-1">
                <input
                        type="checkbox"
                        :name="'answer_shuffle_' + index"
                        :id="'answer-shuffle-' + index"
                        v-on:keydown.enter.prevent=""
                        v-model="answer.shuffle"
                />
                <label class="pr-5 cursor-pointer" :for="'answer-shuffle-' + index">
                    {{ translate('Shuffle answers') }}
                </label>
            </div>
            <div class="p-4 bg-gray-f6 rounded" :class="{ 'is-invalid': answerErrors.length && JSON.parse(answerErrors)[index] !== undefined }">
                <div class="py-1" v-for="(childAnswer, childAnswerIndex) in answer.child_answers"
                     :key="childAnswerIndex">
                    <div class="py-1 font-weight-500">{{ translate('Answer') + ' ' + (+childAnswerIndex + 1) }}</div>
                    <div class="py-1 d-flex">
                        <input
                                class="form-control"
                                type="text"
                                v-model="childAnswer.content"
                                v-on:keydown.enter.prevent=""
                                :id="'answer-input-content-' + index + '-' + childAnswerIndex"
                        />
                        <button class="btn border-0" @click="removeChildAnswer($event, index, childAnswerIndex)">
                            <i class="fa-solid fa-trash-can"></i>
                        </button>
                    </div>
                    <div v-if="answer.type === answerTypes['single-choice']" class="py-1">
                        <input
                                type="radio"
                                :name="'singleChoice_' + index"
                                :id="'answer-radio-correct-' + index + '-' + childAnswerIndex"
                                v-model="answer.correctAnswerIndex"
                                v-on:keydown.enter.prevent=""
                                :value="childAnswerIndex"
                        /> <label class="cursor-pointer"
                                  :for="'answer-radio-correct-' + index + '-' + childAnswerIndex">{{
                        translate('Correct answer')
                        }}</label>
                    </div>

                </div>
                <div class="d-flex justify-content-center w-100">
                    <button class="btn text-primary" @click="addChildAnswer($event, index)">
                        <i class="fa fa-plus"></i> {{ translate('Add option') }}
                    </button>
                </div>
            </div>
            <div v-if="answerErrors.length && JSON.parse(answerErrors)[index] !== undefined">
                <small class="text-danger">{{ JSON.parse(answerErrors)[index] }}</small>
            </div>
        </div>
        <!-- Add button to add more items -->
        <div class="d-flex justify-content-center">
            <button class="btn btn-outline-primary" @click="addMoreAnswer">
                <i class="fa fa-plus"></i> {{ translate('Add answer') }}
            </button>
        </div>
        <input class="d-none" id="answer_list_data" name="answer_list_data" :value="JSON.stringify(answerList)"/>
    </div>
</template>

<script>
export default {
  data() {
    return {
      answerList: $('#js-data').data('answer-list'),
      answerTypes: $('#js-data').data('question-type')['answer-types'],
      answerErrors: $('#js-data').data('errors')
    };
  },
  methods: {
    removeAnswer(e, index) {
      e.preventDefault();
      this.answerList.splice(index, 1);
      QuestionModule.autoFillGrade();
    },
    switchAnswerType(e, index) {
      this.answerList[index].child_answers = [];
    },
    removeChildAnswer(e, index, childAnswerIndex) {
      e.preventDefault();
      this.answerList[index].child_answers.splice(childAnswerIndex, 1);
      if (this.answerList[index].correctAnswerIndex >= this.answerList[index].child_answers.length) {
        if (this.answerList[index].child_answers.length > 0) {
          this.answerList[index].correctAnswerIndex = this.answerList[index].child_answers.length - 1;
        } else {
          this.answerList[index].correctAnswerIndex = 0;
        }
      }
    },
    addChildAnswer(e, index) {
      e.preventDefault();
      // Add a new child answer to the specified question
      this.answerList[index].child_answers.push({
        'content': '',
      });
    },
    addMoreAnswer(e) {
      e.preventDefault();
      // Add a new item to the list
      const newItem = {
        'type': 'single-choice',
        'child_answers': [],
        'shuffle': false,
        correctAnswerIndex: 0 // Add this property to track the selected correct answer
      };
      this.answerList.push(newItem);
      QuestionModule.autoFillGrade();
    },
    translate(string) {
      return this.trans[string] || string
    }
  },
  setup() {
    const trans = $('#js-data').data('trans');
    return {trans}
  },
}
</script>
